__webpack_require__.p = "https://ded-ps-prod.t-static.ru/projects/invest24/prod/0f47fd45902cf6bd1aa0d1fff1f6ab8c31354b79/_next/";